<!--
발송요청 리스트 > 스캔검색 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex uk-flex-bottom" @click="focus">
        <div v-show="scanStorage" class="scanned">
            <span class="header">scanned :</span>
            <span class="storage">{{ scanStorage }}</span>
        </div>

        <form method="get">
            <input
                class="scan-input"
                type="text"
                name="storage"
                placeholder="SCAN STORAGE, HERE"

                ref="scan"
                @keyup.enter="scan"

            />
        </form>

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 스캔한 보관장소
             */
            scanStorage: {
                type: String,
                default: null,
            },

        },
        data: function () {
            return {
            };
        },
        computed: {

        },
        mounted() {
            this.focus();
            // 다른 요소들 로딩된 후에 한번 더 포커스가도록 1초뒤 호출
            setTimeout(() => {
                this.focus();
            }, 500);
        },

        methods: {
            /**
             * 스캔 input 에 포커스를 줌
             */
            focus: function () {
                this.$refs.scan.focus();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .scanned {
        margin-right: 10px;
        font-size: 2rem;

        .header {
            color: #999;
        }
        .storage {
            color: #1e87f0;
        }

    }

    .scan-input {
        font-size: 2rem;
        height: 2.5rem;
        width: 25rem;
        //margin: 40px 0;
        text-align: center;
        border: 1px solid  #333;
        background-color: #fff;
        color: #000;
      &::placeholder {
        color: #999;
      }
        &:focus {//포커싱 상태
            //border: 3px solid  #1e87f0;
            background-color: #FFFF66;
          &::placeholder {
            color: #666;
          }
        }

    }
</style>